/* eslint-disable no-unused-vars */

import React, { useContext } from 'react';
import classnames from 'classnames';
import { Modal } from 'antd';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import { ModalMLStyled } from './ModalMLStyled.js';

/**
 * 头部OK按钮
 * @param {*} param
 */
const ModalML = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  let {
    visible,
    handleOk,
    handleCancel,
    children,
    width,
    height,
    className,
    title,
    id,
    okText,
    cancelText,
    destroyOnClose = true,
  } = props;

  return (
    <ModalMLStyled
      theme={themeContext}
      brand={brandContext}
      className="footBotton"
    >
      <Modal
        title={title}
        id={id}
        centered={true} // 垂直居中展示modal
        destroyOnClose={destroyOnClose}
        maskClosable={false}
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={width || '60vw'}
        className={className}
        bodyStyle={{
          height: height,
          maxHeight: '70vh',
          overflow: 'auto',
        }}
      >
        <div className="popup_more_box">{children}</div>
      </Modal>
    </ModalMLStyled>
  );
};

export default ModalML;
